import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-section-services',
    templateUrl: './section-services.component.html',
    styleUrls: ['./section-services.component.scss'],
    standalone: false
})
export class SectionServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
